import Swiper from "swiper";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

export default function () {
    const root = document.querySelector(
        '.o-news-blog__swiper[data-swiper="blog"]',
    );
    if (!root) return;

    const paginationEl = root.querySelector(".o-news-blog__pagination");

    const slider = new Swiper(root, {
        modules: [Pagination],
        slidesPerView: 1.1,
        spaceBetween: 24,
        pagination: {
            el: paginationEl,
            type: "progressbar",
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                allowTouchMove: false,
            },
            1024: {
                slidesPerView: 3,
                allowTouchMove: false,
            },
        },
    });

    return slider;
}
